export const isKitchenAdmin = scopes => {
  const kitchenAdminScope = 'kitchen/*'
  return scopes && scopes.length > 0 && scopes.indexOf(kitchenAdminScope) > -1
}
